import { render, staticRenderFns } from "./TruckDetailsTachographView.vue?vue&type=template&id=01710984&scoped=true&"
import script from "./TruckDetailsTachographView.vue?vue&type=script&lang=js&"
export * from "./TruckDetailsTachographView.vue?vue&type=script&lang=js&"
import style0 from "./TruckDetailsTachographView.vue?vue&type=style&index=0&id=01710984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01710984",
  null
  
)

export default component.exports